import React from "react";
import { Box, Heading, Text, VStack, Badge } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { LampContainer } from "./lamp"; // same folder as your lamp.tsx
import { Tag } from "@chakra-ui/react";

export default function Hero() {
  return (
    <Box className="lamp" pt={0} pb={8} bg="black" color="white">
      <LampContainer withLampEffect={true}>
        <VStack
          spacing={4}
          textAlign="center"
          px={6}
          justifyContent="center"
          alignItems="center"
          minH="calc(40vh - 100px)"
        >
		<Badge
		  colorScheme="purple"
		  variant="outline"
		  borderRadius="full"
		  px={5}                      // wider
		  py={2}                      // taller
		  fontSize={{ base: "xl", md: "xl" }}
		  borderColor="purple.300"
		  color="purple.100"
		  fontWeight="bold"
		  style={{ boxShadow: "0 0 0 1px rgba(168, 85, 247, .35), 0 0 25px rgba(168, 85, 247, .25)" }}
		  textTransform="uppercase" letterSpacing="0.08em"
		>
		  Gemini Cyber Security
		</Badge>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, ease: "easeInOut" }}
          >
            <Heading
              className="bg-gradient-to-br from-slate-300 via-slate-200 to-slate-300 bg-clip-text text-transparent font-extrabold tracking-tight"
              fontSize={{ base: "3xl", md: "6xl" }}
              lineHeight={{ base: "1.12", md: "1.1"}}
              pb="0.2em"
            >
              Penetration Testing & ISO 27001 Consulting
            </Heading>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 1.4, ease: "easeInOut" }}
          >
            <Text className="text-white" fontSize={{ base: "md", md: "xl" }} maxW="xl">
              With global expertise, Gemini Cyber Security is skilled in both Offensive Security as well as
              Governance Risk and Compliance.
            </Text>
          </motion.div>
        </VStack>
      </LampContainer>
    </Box>
  );
}
